<template>
  <v-dialog v-model="dialog" scrollable max-width="600">
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Detail Grup Dalam {{ isDisableAksi ? 'Tenant' : 'Organisasi' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="my-3">
        <v-row dense v-if="isDisableAksi">
          <v-col cols="12" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="keyword"
              placeholder="Cari Nama Grup"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <v-select
              outlined
              dense
              :items="organisasi"
              item-text="nama"
              item-value="organisasi_id"
              v-model="params.organisasi_id"
              placeholder="Pilih Organisasi"
              clearable
              @change="onPilihOrganisasi"
            ></v-select>
          </v-col>
        </v-row>
        <v-text-field
          v-else
          outlined
          dense
          v-model="keyword"
          placeholder="Cari Nama Grup"
          append-icon="mdi-magnify"
        ></v-text-field>
        <v-alert text type="info">
          <span class="black--text">
            Total semua pengguna pada semua grup adalah
            <b>{{ totalUser }} orang</b>
          </span>
        </v-alert>
        <v-list subheader two-line>
          <v-list-item>
            <v-list-item-content>
              <div>Nama Grup</div>
            </v-list-item-content>

            <div>
              Total Pengguna
            </div>
          </v-list-item>
          <v-divider></v-divider>
          <div v-for="(item, i) in itemList" :key="i">
            <v-list-item
              class="py-2"
              @click="onDetail(item)"
              :style="{ cursor: isDisableAksi ? 'default' : 'pointer' }"
            >
              <v-list-item-avatar>
                <v-icon class="primary" dark>
                  mdi-hospital-building
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <div class="primary--text body-1 font-weight-medium" v-text="item.nama"></div>
              </v-list-item-content>

              <v-list-item-action-text>
                <div class="body-2"
                  ><b>{{ item.jumlah || 0 }}</b> Anggota</div
                >
              </v-list-item-action-text>
            </v-list-item>
            <v-divider></v-divider>
          </div>
        </v-list>

        <div class="text-center">
          <v-pagination v-model="page" :length="total" circle></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      params: {},
      items: [],
      limit: 4,
      page: 1,
      keyword: '',
      organisasi: [],
    }
  },
  computed: {
    filteredDokumen() {
      let items = this.items || []
      return items.filter((item) => {
        return item.nama.toLowerCase().includes(this.keyword.toLowerCase())
      })
    },

    itemList() {
      const start = this.page === 1 ? 0 : this.limit * (this.page - 1)
      const finish =
        this.page === 1
          ? this.limit
          : this.filteredDokumen.length > this.page * this.limit
          ? this.page * this.limit
          : this.filteredDokumen.length
      return this.filteredDokumen.slice(start, finish)
    },

    total() {
      return parseInt(Object.keys(this.filteredDokumen).length / this.limit + 1) || 0
    },

    totalUser() {
      let result = 0

      this.items.forEach((item) => {
        result += item.jumlah
      })

      return result
    },

    isDisableAksi() {
      return !this.organisasi_id
    },
  },
  methods: {
    open() {
      this.reset()
      this.$store
        .dispatch('grup/get', {
          organisasi_id: this.organisasi_id || this.tenant_id,
          params: { count: 500, is_jumlah: 1 },
        })
        .then(({ data }) => {
          this.items = (data && data.data) || (data) || {}
          this.dialog = true
        })
    },

    onReload() {
      this.$store
        .dispatch('grup/get', {
          organisasi_id: this.organisasi_id || this.tenant_id,
          params: Object.assign(this.params, { count: 500, is_jumlah: 1 }),
        })
        .then(({ data }) => {
          this.items = (data && data.data) || (data) || {}
        })
    },

    reset() {
      this.items = []
      this.params = {}
    },

    onDetail(item) {
      if (!this.organisasi_id) return
      this.dialog = false
      this.$router.push({
        name: 'grup.detail',
        params: {
          organisasi_id: this.organisasi_id,
          group_id: item.group_id,
        },
      })
    },

    onPilihOrganisasi() {
      this.onReload()
    },
  },
}
</script>
